import _typeof from "@babel/runtime/helpers/typeof";
import { mixin } from '../utils';
export function isDOM(obj) {
  return _typeof(obj) === 'object' && obj.nodeType === 1 && _typeof(obj.style) === 'object' && _typeof(obj.ownerDocument) === 'object';
}
export function $(selector, parent) {
  if (!parent) return document.querySelector(selector);
  if (isDOM(parent)) return parent.querySelector(selector);
  return document.querySelector(selector);
}
export function addRule(selector, cssObj) {
  Object.keys(cssObj).forEach(function (item) {
    selector.style[item] = cssObj[item];
  });
}
export function findIndex(ele, currentTag) {
  var nth = 0;
  while (ele) {
    if (ele.nodeName.toLowerCase() === currentTag) nth += 1;
    ele = ele.previousElementSibling;
  }
  return nth;
}
function findPos(ele) {
  var computedStyle = getComputedStyle(ele);
  var _x = ele.getBoundingClientRect().left - parseFloat(computedStyle['margin-left']);
  var _y = ele.getBoundingClientRect().top - parseFloat(computedStyle['margin-top']);
  var el = ele.parent;
  while (el) {
    computedStyle = getComputedStyle(el);
    _x += el.frameElement.getBoundingClientRect().left - parseFloat(computedStyle['margin-left']);
    _y += el.frameElement.getBoundingClientRect().top - parseFloat(computedStyle['margin-top']);
    el = el.parent;
  }
  return {
    top: _y,
    left: _x
  };
}
export function getElementInfo(ele) {
  var result = {};
  var requiredValue = ['border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'z-index'];
  var computedStyle = getComputedStyle(ele);
  requiredValue.forEach(function (item) {
    result[item] = parseFloat(computedStyle[item]) || 0;
  });
  mixin(result, {
    width: ele.offsetWidth - result['border-left-width'] - result['border-right-width'] - result['padding-left'] - result['padding-right'],
    height: ele.offsetHeight - result['border-top-width'] - result['border-bottom-width'] - result['padding-top'] - result['padding-bottom']
  });
  mixin(result, findPos(ele));
  return result;
}
export function isParent(obj, parentObj) {
  while (obj !== undefined && obj !== null && obj.tagName.toUpperCase() !== 'BODY') {
    if (obj == parentObj) return true;
    obj = obj.parentNode;
  }
  return false;
}
export var getDomRect = function getDomRect(child, mouseLocation) {
  return mouseLocation ? {
    left: mouseLocation.clientX,
    top: mouseLocation.clientY,
    width: 0,
    height: 0,
    right: mouseLocation.clientX,
    bottom: mouseLocation.clientY
  } : child.getBoundingClientRect();
};
export default $;